import {
  GET_INTRANSIT_REPORT_REQUEST,
  GET_INTRANSIT_REPORT_SUCCESS,
  GET_INTRANSIT_REPORT_ERROR,
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";

export const intransitReport = (token, data, isGenerate, isSKU ) => (dispatch) => {
  dispatch({ type: GET_INTRANSIT_REPORT_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/Stylewiseintransitreport`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: {
      gender_id: isGenerate === undefined || isGenerate === "All" ? null : isGenerate ,
      
      gender_category_id: null,
      sku: isSKU === "All" ? null : isSKU,
      style_id: data.style_id === undefined || data.style_id === "All" ? null : data.style_id,
      
      product_status_id: null,
      season_id: data.current_season_id === undefined || data.current_season_id === "All" ? null : data.current_season_id,
      wash_id: data.wash_id === undefined || data.wash_id === "All" ? null : data.wash_id
    },
  })
    .then((response) => {
      return dispatch({
        type: GET_INTRANSIT_REPORT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_INTRANSIT_REPORT_ERROR,
        payload: [],
      });
    });
};
